<template>
  <header>
    <div class="headerBg">
      <div class="headerCenter">
        <a href="#" class="headerLogoArea">
          <img src="@/assets/img/surreal_ed_logo.png" class="headerLogoImg" />
          <span class="headerLogoTxt">英語小鬥士風雲榜後台</span>
        </a>
      </div>
    </div>
    <!-- Header的底 -->
    <div style="width: 100%; height: 86px;"></div>
  </header>
</template>
<script>
export default {
  name: "Header",
  mounted() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

